import React from 'react'

const LLM = (props) => {
    const { item } = props

   
    let data = item.split('\n').map(part => part.trim()).filter(part => part.length > 0);

    // Join the parts back with HTML line breaks for proper formatting
    // const htmlString = item.replace(/\n/g, '<br>');
    const htmlString = item.replace(/\n/g, '<br>');
    

    // const [title, instructionsText] = item.value.split('\n\n' || '\n');

    // const instructions = instructionsText?.split('\n')
    // .map(instruction => instruction.replace(/^\d+\.\s*/, '')) // Remove the number at the start of each instruction
    // .filter(instruction => instruction.trim().length > 0); // Filter out empty instructions (if any)
  
    return (
        <div key={'title'}>
            {" "}
            <div style={{ padding: "8px" }} className="header-prob">
                LLM
            </div>
            {/* <span  style={{ padding: "8px" }}className='llm-list' >{title}</span> */}
            <div style={{ marginLeft: '20px', overflowWrap: 'break-word'  }} dangerouslySetInnerHTML={{ __html: htmlString }} className='system-check-para' />
        </div>
    )
}

export default LLM
